var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.recommendationAvailable)?_c('span',[_c('sweet-button',{attrs:{"variant":"primary","icon":"mdi mdi-check","size":"sm","buttonClass":"mt-2 ml-2 float-right"},on:{"click":function($event){return _vm.applyRecommendation()}}},[_vm._v(" "+_vm._s(_vm.$t("common.apply-recommendation"))+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }